import axios from 'axios';

import { is_production } from 'config';

axios.defaults.baseURL = is_production
  ? 'https://api.richquack.com/api/v1/'
  : 'https://dev-richquack.rocknblock.io/api/v1/';

export default axios;
